import TemplateView from '../../../TemplateView'
import $ from "jquery"

export default class IframeContent extends TemplateView {

    constructor({
        iframeLoadCallback,
        frameName,
    }) {
        super()

        this.callbacks = {
            iframeLoadCallback,
        }

        this.state = {
            url: '',
            size: {
                width: 0,
                height: 0
            },
        }

        this.params = {
            frameName
        }


        this.onStatePropertyChanged('url', url => {
            this.$el.empty()
            if (!url) {
                return
            }

            this.iframe = $('<iframe>', {
                src: url,
                id: this.params.frameName,
                frameborder: 0,
                width: this.state.size.width,
                height: this.state.size.height,
                name: this.params.frameName,
            })
            this.iframe.appendTo('.iframeContainer')
            this.iframe.load(() => this.callbacks.iframeLoadCallback(this.params.frameName))
        })

        this.onStatePropertyChanged('size', size => {
            if (this.iframe) {
                this.iframe.width(size.width)
                this.iframe.height(size.height)
            }
        })
    }

    templateHtml() {
        return `<div class="iframeContainer">
                </div>`
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/IframeContent.js